import { Trans } from "@lingui/react/macro";
import { ChatMarkdown } from "@rakazo/chat-ui/web";
import type { QuestionBrief as Brief } from "@rakazo/contracts";

export function QuestionBrief({ brief }: { brief: Brief }) {
  return <div className="mt-3 space-y-3 text-sm" data-testid="question-brief">
    <div className="text-muted-foreground"><ChatMarkdown>{brief.background}</ChatMarkdown></div>
    {brief.recommendation ? <div className="rounded-lg bg-muted/60 px-3 py-2">
      <p className="mb-1 font-medium"><Trans>Recommendation</Trans></p>
      <ChatMarkdown>{brief.recommendation}</ChatMarkdown>
    </div> : null}
    {brief.evidence?.length ? <details className="text-muted-foreground">
      <summary className="cursor-pointer font-medium text-foreground"><Trans>Supporting facts</Trans></summary>
      <ul className="mt-2 list-disc space-y-2 pl-5">{brief.evidence.map((fact, index) => <li key={index}>
        <ChatMarkdown>{fact.text}</ChatMarkdown>
        {fact.url ? <a className="underline underline-offset-2" href={fact.url} target="_blank" rel="noopener noreferrer"><Trans>View source</Trans></a> : null}
      </li>)}</ul>
    </details> : null}
  </div>;
}
